<template>
  <!-- 5-4-2 医疗机关消息回复页面 -->
  <div class="main-css">
    <div class="main-box-css-all">
      <div class="main-box">
        <!-- 左边查看信息部分 -->
        <div class="left-box">
          <!-- 主要显示box 滚动条隐藏部分 -->
          <div class="left-main-box">
            <!-- 第一行 -->
            <div class="one-line-box">
              <div class="avt-img">
                <img src="./assets/Ellipse 5.png" alt="" />
              </div>
              <div class="big-form-box">
                <span>{{ $t("institutionName") }}</span>
                <p class="institution-main">{{ institutionName }}</p>
                <!-- 认证部分 -->
                <div class="certified">{{ $t("certified") }}</div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("postCode") }}</span>
                <p class="small-box-title">{{ postCode }}</p>
              </div>
              <div class="big-box">
                <span>{{ $t("location") }}</span>
                <p class="small-box-title">{{ area }}</p>
              </div>
            </div>
            <!-- 第三行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("institutionalAttributes") }}</span>
                <p class="small-box-title">{{ agencyAttribute }}</p>
              </div>
              <div class="big-box">
                <span>{{ $t("hpOrSns") }}</span>
                <p class="small-box-title">{{ hPorSNS }}</p>
              </div>
            </div>
            <!-- 第四行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("representativeName") }}</span>
                <p class="small-box-title">{{ representativeName }}</p>
              </div>
              <div class="big-box">
                <span>{{ $t("institutionalNumber") }}</span>
                <p class="small-box-title">{{ phoneNumber }}</p>
              </div>
            </div>
            <!-- 第五行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("registeredCapital") }}</span>
                <p class="small-box-title">{{ capital }}</p>
              </div>
              <div class="most-small-box" style="margin-right: 12px">
                <span>{{ $t("numberStaff") }}</span>
                <p class="small-box-title">{{ frequency }}</p>
              </div>
              <div class="most-small-box">
                <span>{{ $t("numberOfBets") }}</span>
                <p class="small-box-title">{{ numberBets }}</p>
              </div>
            </div>
            <!-- 第六行 -->
            <div class="textarea-line-box">
              <div class="textarea-box">
                <span>{{ $t("businessContent") }}</span>
                <p class="textarea-css-main">{{ textData }}</p>
              </div>
            </div>
            <!-- table 部分 -->
            <div class="table-line">
              <el-table
                @row-click="qaq"
                :data="tableData"
                style="width: 100%"
                height="450"
                @sort-change="changeTableSort"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="jobName" label="案件名" width="200" :show-overflow-tooltip="true">
                  <template slot="header">
                    <p>{{ $t("caseName") }}</p>
                    <el-input
                      v-model="tableSearch1"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.jobName }}
                  </template>
                </el-table-column>
                <el-table-column prop="workSpace" label="勤務地" width="100":show-overflow-tooltip="true">
                  <template slot="header">
                    <p>{{ $t("workLocation") }}</p>
                    <el-input
                      v-model="tableSearch2"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.workSpace }}
                  </template>
                </el-table-column>
                <el-table-column prop="endTime" label="掲載日":show-overflow-tooltip="true">
                  <template slot="header">
                    <p>{{ $t("payonTheDay") }}</p>
                    <el-input
                      v-model="tableSearch3"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.endTime }}
                  </template>
                </el-table-column>
                <el-table-column prop="visitedTime" label="観覧回数" :sortable="'custom'":show-overflow-tooltip="true">
                  <template slot="header">
                    <p class="empty-ps">    {{ $t("numberOfVisits") }}</p>

                    <p class="empty"></p>
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.visitedTime }}
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页部分 -->
              <div class="pagination">
                <div class="el-pagination">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout=" prev, pager, next"
                    :total="100"
                    :page-size="pageSize"
                    small
                  >
                  </el-pagination>
                </div>
                <div class="rowsPage">
                  <span>Rows per page</span>
                  <div class="rowsPage-css">
                    <el-dropdown @command="handleCommand">
                      <span class="el-dropdown-link">
                        7<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">7</el-dropdown-item>
                        <el-dropdown-item command="b">15</el-dropdown-item>
                        <el-dropdown-item command="c">20</el-dropdown-item>
                        <el-dropdown-item command="d">25</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边聊天部分 -->
        <div class="right-box">
          <Socket></Socket>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="main-button">
        <button  @click="shouye">{{ $t("close") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import {
  queryMedicalInstitutionInfo,
  medicalInstitutionListQuery,
  queryMedicalInstitutionDetailInfo,
  recruitmentInformationDetails,
  medicalInstitutionDetailsQuery,
  educationalInstitutionDisplay
} from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "medicalInformationReply",
  components: { Socket },
  data() {
    return {
      //列表数据
      tableData: [
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570", //観覧回数
        },
      ],
      tableSize: 5,
      total: 50,
      institutionName: "", //機関名
      postCode: "", //郵便番号
      area: "", //所在地
      agencyAttribute: "", //機関属性
      hPorSNS: "", //HP or SNS
      representativeName: "", //代表者氏名
      phoneNumber: "", //機関の電話番号
      numberEmployees: "", //授業員数
      numberBets: "", //ベット数
      capital: "", //資本金
      textData: "", //事业内容
      frequency:"",//職員数

      projectTitleSearch: "", //案件名搜索框
      workLocationSearch: "", //勤務地搜索框
      publicationDateSearch: "", //掲載日搜索框
      loading: false,
      currentPage: 1, //页数
      pageSize: 7, //每页条数

      tableSearch1:"", //案件名
      tableSearch2:"", //勤務地
      tableSearch3:"", //掲載日

    };
  },
  created() {
    console.log(this.$route.query.medicalId)
    this.getList()
  },
  computed: {},
  methods: {
    shouye(row,event,column){
      this.$router.push({
        name: 'medicalIndex',
        // params:{ id: row.jobId}
      });
      console.log(row);
    },
    qaq(row,event,column){
      this.$router.push({
        name: 'medicalInstitutionCaseManagementDetails',
        params:{ id: row.jobId}
      });
      console.log(row);
    },
    //接口 获取表格数据
    getList(){
      console.log(this.$route.query.medicalId);
      //左侧数据获取
      var fakeInfo = {
        medicalId: this.$route.query.medicalId,
        // medicalId: "59ff0657d6c311ecbac800ffd1723a85",
        "pageNumber": 1,
        "pageSize": 15
      };
      // queryMedicalInstitutionInfo(fakeInfo)
      // medicalInstitutionDetailsQuery(fakeInfo)
      queryMedicalInstitutionDetailInfo(fakeInfo)
        .then((res) => {
          console.log("--------管理员查询医疗机构详细信息接口--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)
            this.totalItem = aesFecInfo.total
            this.institutionName = aesFecInfo.medicalName     //機関名
            this.postCode = aesFecInfo.postNumber             //郵便番号
            this.area = aesFecInfo.address                    //所在地
            this.agencyAttribute = aesFecInfo.attributes      //機関属性
            this.hPorSNS = aesFecInfo.hpOrSns                 //HP or SNS
            this.representativeName = aesFecInfo.legalPerson  //代表者氏名
            this.phoneNumber = aesFecInfo.telephone           //機関の電話番号
            this.capital = aesFecInfo.capitalAmount           //資本金
            this.frequency = aesFecInfo.employeeNumber        //職員数
            this.numberBets = aesFecInfo.bedNumber            //ベット数
            this.textData = aesFecInfo.introduction           //事業内容
            this.numberEmployees = aesFecInfo.employeeNumber
            console.log("链接成功");
          } else {
            this.$message.error('登录失败。');
          }
        })
        .catch((res) => {});
      //下面数据获取
      var fakeInfo2 = {
        medicalId: this.$route.query.medicalId,
        // medicalId: "59ff0657d6c311ecbac800ffd1723a85",
      };
      medicalInstitutionDetailsQuery(fakeInfo2)
        .then((res2) => {
          console.log("--------案件接口--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data))
            console.log(aesFecInfo2)
            this.totalItem = aesFecInfo2.medicalInstitution
            this.tableData = aesFecInfo2.caseList
            console.log("链接成功");
          } else {
            this.$message.error('登录失败。');
          }
        })
        .catch((res) => {});
    },
    change(e) {
      this.$forceUpdate();
    },
    //表格排序
    changeTableSort(custom) {
      console.log(custom);
      if (custom.order === "ascending") {
        this.tableData = this.tableData.sort(
          (a, b) => a["numberViewing"] - b["numberViewing"]
        );
      } else if (custom.order === "descending") {
        this.tableData = this.tableData.sort(
          (a, b) => b["numberViewing"] - a["numberViewing"]
        );
      }
    },
    // 案件名search
    handleProjectTitleSearch() {
      console.log("案件名search");
      console.log(this.projectTitleSearch);
    },
    // 勤務地search
    handleWorkLocationSearch() {
      console.log("勤務地search");
      console.log(this.workLocationSearch);
    },
    // 掲載日search
    handlePublicationDateSearch() {
      console.log("掲載日search");
      console.log(this.publicationDateSearch);
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
    },
    // 分页页数变化
    handleCurrentChange() {},
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  display: flex;
}
.main-box-css-all {
  width: 1200px;
  margin: 0 auto;
}
.left-box {
  width: 550px;
  height: 650px;
  margin: 40px 50px 0 0px;
  overflow: hidden;
}
.left-main-box {
  width: 567px;
  height: 650px;
  overflow-y: scroll;
  padding-right: 17px;
  box-sizing: border-box;
}
.one-line-box {
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
}
.avt-img {
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 50%;
}
.big-form-box {
  height: 57px;
  width: 299px;
  border-radius: 8px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  margin-left: 30px;
  margin-top: 50px;
  position: relative;
}
.certified {
  width: 49px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  letter-spacing: -0.02em;
  color: #ffffff;
  position: absolute;
  right: 0;
  top: -22px;
}
.big-form-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.other-line-box {
  width: 100%;
  height: 45px;
  margin-top: 24px;
  display: flex;
}
.small-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 10px;
}
.small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.big-box {
  width: 292px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.most-small-box {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.most-small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.textarea-line-box {
  width: 100%;
  height: 180px;
  margin-top: 24px;
  display: flex;
}
.textarea-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.table-line {
  margin-top: 24px;
  width: 500px;
  height: 450px;
}
.table-line /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}
.number-viewing {
  position: relative;
}
.table-line /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 0;
}
.table-line .empty {
  height: 30px;
}
.right-box {
  background: #fff;
  width: 550px;
  height: 650px;
  margin-top: 40px;
}
.main-button {
  width: 500px;
  height: 50px;
  text-align: center;
  margin-top: 20px;
}
.main-button button {
  cursor: pointer;
  height: 40px;
  width: 152px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  display: flex;
  justify-content: right;
}
.rowsPage {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  display: inline-block;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
}
.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInformationReply/index.vue